"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakpoint = breakpoint;

var _styledComponents = require("styled-components");

var _mediaQueryFns = require("../breakpoints/mediaQueryFns");

function breakpoint(breakpointName, styles) {
  var mediaQueryFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _mediaQueryFns.mediaQueryAbove;
  return function (_ref) {
    var theme = _ref.theme;
    var breakpointIndex = theme.breakpoints.breakpointNames.findIndex(function (bp) {
      return bp === breakpointName;
    });

    if (breakpointIndex >= 0) {
      return (0, _styledComponents.css)(["@media ", "{", "}"], mediaQueryFn(theme.breakpoints, breakpointIndex), styles);
    }

    return null;
  };
}